import { Directive, ElementRef, inject, OnInit } from '@angular/core';
import { ContentModel } from '@libs/cms/models';
import { GTMPageBlockTrackingModel } from '@libs/shared/models';
import {
  CONTENT_TRACKING_CONTEXT,
  CONTENT_TRACKING_DATA,
  ContentTrackingContext,
  ContentTrackingData,
  TrackingDataFields,
} from '../context';
import { TrackingMapperService } from '../mapper';
import { PageBlockImpressionObserverService } from './page-block-impression-observer-service';

@Directive({
  selector: '[uiPageBlockImpression]',
})
export class PageBlockImpressionDirective implements OnInit {
  public readonly contentTrackingContext: ContentTrackingContext | null = inject(CONTENT_TRACKING_CONTEXT, { optional: true });
  public readonly contentTrackingData: ContentTrackingData | null = inject(CONTENT_TRACKING_DATA, { optional: true });
  private readonly trackingMapper: TrackingMapperService = inject(TrackingMapperService);

  public constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly impressionObserver: PageBlockImpressionObserverService,
  ) {
  }

  public ngOnInit(): void {
    const context: ContentModel | undefined = this.contentTrackingContext?.data();
    const trackingData: TrackingDataFields | undefined = this.contentTrackingData?.data();

    if (!context) {
      return;
    }

    const event: GTMPageBlockTrackingModel = this.trackingMapper.mapPageBlockToPageBlockTracking(context, trackingData);

    this.impressionObserver.observeElement(this.elementRef.nativeElement, event);
  }
}
